import { connect } from "react-redux";
import { ApplicationState } from "../../store";
import ApiProgressIndicator from "./api-progress-indicator";
import { ApiProgressIndicatorProps } from "./api-progress-indicator.props";

type StateProps = Pick<
  ApiProgressIndicatorProps,
  "progress" | "isVisible" | "message"
>;

const mapStateToProps = (state: ApplicationState): StateProps => ({
  progress: state.ui.apiProgress.progress,
  isVisible: state.ui.apiProgress.isVisible,
  message: state.ui.apiProgress.message,
});

const ApiProgressIndicatorContainer =
  connect(mapStateToProps)(ApiProgressIndicator);

export { ApiProgressIndicatorContainer };
